import { createProvider } from '@nvision/services/data-provider';

import type { CitiesParams } from '../../models';
import * as api from './api';
import { normalizeCities } from './normalize';

export const fetchCities = createProvider(
  async (params: CitiesParams, { signal }: { signal?: AbortController['signal'] } = {}) => {
    const response = await api.fetchCities(params, { signal });
    return normalizeCities(response);
  },
);
